import { useEffect } from "react";

import { refreshNeucleosWorlds } from "./worldStore";

/**
 * W-4a6095af (Can 31): the server tells every open window when this Mac's
 * sign-in changes (the config stream pushes a new event on each session
 * change: a sign-in, a sign-out, or the World ending a grant). Each new event
 * re-reads the status, so an open window shows "Signed out" when the World
 * ended the sign-in instead of at the next six-hour read. Overlapping reads
 * are ordered by refreshNeucleosWorlds.
 */
export function useWorldsFollowServer(latestServerEvent: unknown): void {
  useEffect(() => {
    if (latestServerEvent === null || latestServerEvent === undefined) return;
    void refreshNeucleosWorlds().catch(() => undefined);
  }, [latestServerEvent]);
}
